import React, { memo } from 'react';
import BatchErrorsTable from '@components/batch/batch-errors-table';
import UnstyledHeading from '@shared/unstyled-heading';
import '../portal/details/sections.scss';

const BatchErrorsSection = () => (
  <div styleName="sections-container">
    <div key="batch_errors" styleName="sections-section">
      <UnstyledHeading rank={3} routeFocusSkip styleName="sections-title">Errors</UnstyledHeading>
    </div>
    <BatchErrorsTable />
  </div>
);

export default memo(BatchErrorsSection);
